import React from 'react';
import { Button } from '@mui/material';
import { COLORS } from '@fupa/fupa-uikit';
import { useSoftTickerContext } from 'app/hooks/useSoftTickerContext';
import { openAddScorer } from 'app/actions/softTickerActions';
import styled from 'styled-components';
const SCButton = styled(Button).withConfig({
  componentId: "sc-acrlyx-0"
})(["display:flex;margin:0 auto;&,&:hover,&:active,&:focus{background-color:", ";color:", ";},"], COLORS.lightestGrey, COLORS.fupaSecondary);
export default function AddScorerButton() {
  const {
    dispatch
  } = useSoftTickerContext();
  const handleClick = () => {
    dispatch(openAddScorer('layer_add_scorer'));
  };
  return /*#__PURE__*/React.createElement(SCButton, {
    variant: "contained",
    onClick: handleClick,
    "data-sentry-element": "SCButton",
    "data-sentry-component": "AddScorerButton",
    "data-sentry-source-file": "AddScorerButton.tsx"
  }, "+ Torsch\xFCtze hinzuf\xFCgen");
}